import { render } from "./LearningDevelopmentSection.vue?vue&type=template&id=1f4134ac&scoped=true"
import script from "./LearningDevelopmentSection.vue?vue&type=script&lang=js"
export * from "./LearningDevelopmentSection.vue?vue&type=script&lang=js"

import "./LearningDevelopmentSection.vue?vue&type=style&index=0&id=1f4134ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4134ac"]])

export default __exports__